import { writable } from 'svelte/store';

export const currentTool = writable<'Redirect' | 'Routing'>('Redirect');
